// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__VvSNY","content":"styles_content__2shKw","selectAll":"styles_selectAll__QTHaJ"};